import { useState, useCallback, useMemo } from 'react';
import { getSelectedIds, getSelectedCount, isAllSelected, getUnselectedIds } from '../utils/gridHelpers';

const useGridSelection = () => {
  const [selectionRef, setSelectionRef] = useState({
    selected: {},
    unselected: null
  });

  const selectedIds = useMemo(() => {
    if (isAllSelected(selectionRef)) {
      return { allSelected: true, unselectedIds: getUnselectedIds(selectionRef.unselected) };
    }
    return { allSelected: false, selectedIds: getSelectedIds(selectionRef.selected) };
  }, [selectionRef]);

  const selectedCount = useMemo(() => {
    return getSelectedCount(selectionRef.selected);
  }, [selectionRef.selected]);

  const handleSelectionChange = useCallback((selection) => {
    setSelectionRef(selection);
  }, []);

  const deselectAll = useCallback(() => {
    setSelectionRef({
      selected: {},
      unselected: null
    });
  }, []);

  const hasSelection = useMemo(() => {
    return selectedCount > 0 || isAllSelected(selectionRef);
  }, [selectedCount, selectionRef]);

  return {
    selectionRef,
    selectedIds,
    selectedCount,
    hasSelection,
    handleSelectionChange,
    deselectAll
  };
};

export default useGridSelection;
